import {Context} from '@/project'
import {TransformerResponse} from '@/lib/axiosAddTransforms'

const dataJsonParse: TransformerResponse<Context> = (data) => {
  if(typeof data === 'string') {
    try {
      return JSON.parse(data)
    } catch(e) {
      return data
    }
  }
  return data
}

export default dataJsonParse
